module.exports = __webpack_public_path__ + "img/no-goals-assigned.34e0d7bb.png";